import React,{Component} from 'react'
// import _ from 'lodash'

// import { AreaChart, Area, XAxis, YAxis, Tooltip } from 'recharts';
// import {BarChart, Bar, XAxis, YAxis, Tooltip, Legend} from 'recharts';
import {
  PieChart,
  Pie,
  // Sector,
  Cell,
  Tooltip,
  Legend,
} from 'recharts'

import SkeletonCard from './SkeletonCard'

import {
  Accent,
  Primary,
  Purple,
} from '../helper/consts'

// const data = [
//   {name: 'Group A', value: 400},
//   {name: 'Group B', value: 300},
//   {name: 'Group C', value: 300},
//   {name: 'Group D', value: 200},
// ];

export default class AdminJobsPieChart extends Component{
  constructor(props){
    super(props)

    this.state = {
      loading:true,
    }
  }

  componentDidMount(){
    let {data} = this.props;
    let formatted = [];
    let active = 0;
    let hired = 0;
    let other = 0;
    // let total = Object.keys(data).length;
    let counter = Object.keys(data).length
    if(counter===0){
      this.setState({
        data:formatted,
        loading:false,
        colors:[Primary,Accent,Purple,]
      })
      return
    }
    else {
      Object.keys(data).forEach(jid=>{
        let job = data[jid];
        // let obj = {};
        if(job.status==='published'){
          active++;
        }
        else if(job.status==='hired'){
          hired++;
        }
        else{
          other++;
        }
        counter--;
        if(counter===0){
          active>0 && formatted.push({[`name`]: 'Active',[`value`]: active,})
          hired>0 && formatted.push({[`name`]: 'Hired',[`value`]: hired,})
          other>0 && formatted.push({[`name`]: 'Other',[`value`]: other,})
          this.setState({
            data:formatted,
            loading:false,
            colors:[Primary,Accent,Purple,]
          })
        }
      })
    }
  }

  render () {
    const {data} = this.state;
    // console.log(this.state);
    return (
      this.state.loading?
        <SkeletonCard contents={true} />
      :
        <PieChart
          width={288}
          height={300}
          onMouseEnter={this.onPieEnter}
        >
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={1}
          >
            {
              data.map((entry, index) => <Cell key={index} fill={this.state.colors[index]}/>)
            }
          </Pie>
          <Tooltip/>
          <Legend />
        </PieChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminJobsPieChart.js